import React from 'react';
import "./Education.css";
import {Qualification} from "../../../../Constants/Constants";

function Education() {
    const edList = Qualification.map(ed => (<li> I completed my <strong>{ed.degree }</strong> in <strong>{ed.year}</strong> from <strong>{ed.institute}</strong> </li>))     
    return (
        <div className="education">
        <div className="headingBackground"> <h2>My Qualifications</h2> </div>
        <div className="contentBackground"> {edList}</div>
        </div>
    )
}

export default Education
